import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=dc94e8de&scoped=true"
import script from "./Publication.js?vue&type=script&lang=js&external"
export * from "./Publication.js?vue&type=script&lang=js&external"
import style0 from "./Publication.scss?vue&type=style&index=0&id=dc94e8de&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc94e8de",
  null
  
)

export default component.exports